import { render, staticRenderFns } from "./clazzrule.vue?vue&type=template&id=68b6978e&scoped=true&"
import script from "./clazzrule.vue?vue&type=script&lang=js&"
export * from "./clazzrule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b6978e",
  null
  
)

export default component.exports